import React, { useCallback } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { validateField } from '../../utils/validation/validation';
import InputField from '../../utils/InputField';
import { faPlus, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import ListGroup from 'react-bootstrap/ListGroup';
import Dropzone from "../../utils/dropzone";
import GoogleMapsWrapper from '../../utils/GoogleMapsWrapper'; 
import PlaceComponent from '../Address/AddressAutoPop';
import { formatPhoneNumber } from '../../utils/phoneFormatter';

const ContractorForm = React.memo(({ 
    data, 
    contractors, 
    onChange, 
    onAddOrUpdateContractor, 
    onSelectContractor, 
    onValidate, 
    errors, 
    buttonText, 
    isFrom = 'page' 
}) => {
    const handleChange = useCallback((field, value) => {
        let processedValue = value;
        
        // Format phone number
        if (field === 'phoneNumber') {
            processedValue = formatPhoneNumber(value);
        }
        
        onChange(field, processedValue);
        const error = validateField(field, processedValue);
        onValidate(field, error);
    }, [onChange, onValidate]);

    const handleFileUpload = useCallback((fieldName, uploadedFiles) => {
        console.log('Files uploaded to field:', fieldName, uploadedFiles);
        onChange(fieldName, uploadedFiles); 
    }, [onChange]);

    return (
        <Container className="px-0" fluid>
            <Row className="no-gutters upper-wrap">
                <Col sm={isFrom === 'page' ? 4 : 12 } xs="12">
                    <div className="form-wrapper rounded mb-4">
                        <div className="form-heading mb-4 text-uppercase fw-bold">
                            Contractor
                        </div>
                        {contractors?.length > 0 && (
                            <ListGroup as="ol">
                                {contractors.map((contractor, index) => (
                                    <ListGroup.Item
                                        as="li"
                                        className="d-flex justify-content-between align-items-center mb-3 contractor-list"
                                        key={index}
                                        action 
                                        onClick={() => onSelectContractor(index)}
                                    >
                                        <div className="ms-2 me-auto">
                                            {contractor.individualName}
                                        </div>
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        )}
                        <button onClick={onAddOrUpdateContractor} type="button" className="btn btn-next mt-3">
                            <FontAwesomeIcon icon={faPlus} /> {buttonText}
                        </button>
                    </div>
                </Col>
                <Col sm={isFrom === 'page' ? 8 : 12 } xs="12">
                    <div className="form-wrapper rounded">
                        <div className="form-heading mb-4 text-uppercase fw-bold">
                            Contractor Information
                        </div>
                        <Row className="mb-3">
                            <InputField
                                field="individualName"
                                label="Company or Individual Name"
                                placeholder=""
                                value={data.individualName}
                                onChange={handleChange}
                                error={errors.individualName}
                                as={Col}
                                controlId="contractor"
                            />
                        </Row>
                        <Row className="mb-3">
                            <InputField
                                field="trade"
                                label="Applicable Trade(s)"
                                value={data.trade}
                                onChange={handleChange}
                                error={errors.trade}
                                as={Col}
                                controlId="contractor"
                            />
                        </Row>
                        <Row className="mb-3">
                            <InputField
                                field="email"
                                type="email"
                                label="Email Address"
                                placeholder=""
                                value={data.email}
                                onChange={handleChange}
                                error={errors.email}
                                as={Col}
                                controlId="contractor"
                            />
                        </Row>
                        <Row className="mb-3">
                            <InputField
                                field="phoneNumber"
                                label="Phone Number"
                                placeholder=""
                                value={data.phoneNumber}
                                onChange={handleChange}
                                error={errors.phoneNumber}
                                pattern="^[-0-9]*$"
                                type="text"
                                as={Col}
                                controlId="contractor"
                            />
                        </Row>
                        <Row className="mb-3">
                            <GoogleMapsWrapper>
                                <PlaceComponent
                                    field="address"
                                    label="Contractor Address"
                                    className="mb-3"
                                    value={data.address}
                                    onChange={handleChange}
                                    type="text"
                                    error={errors.address}
                                    controlId="contractor"
                                />
                            </GoogleMapsWrapper> 
                        </Row>
                        <div className="form-heading mt-5 text-uppercase fw-bold">
                        Contractor License & Proposal Documents (Only PDF)
                        </div>
                        <Dropzone fileTypes={['application/pdf']} showPreview={true} fieldName="license" onFileUpload={handleFileUpload} />
                        {(isFrom !== 'page' && data.licenseLink?.length > 0) && (
                            <Row>
                                <Col sm="12">
                                    <div className="form-wrapper rounded mt-2">
                                        <div className="form-heading text-uppercase fw-bold">
                                            Download/View Documents
                                        </div>
                                        <ListGroup as="ul">
                                            {data?.licenseLink.map((file, index) => (
                                                <ListGroup.Item as="li" key={index}>
                                                    <a href={file.link} target="_blank" rel="noopener noreferrer">
                                                        File {index + 1}
                                                    </a>
                                                </ListGroup.Item>
                                            ))}
                                        </ListGroup>
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </div>
                </Col>
            </Row>
        </Container>
    );
});

export default ContractorForm;
